import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungViersen() {
  return (
    <CityPageTemplate
      city="Viersen"
      slug="viersen"
      intro="Viersen am Niederrhein – digitale, unabhängige Finanzberatung ohne versteckte Kosten."
      description="Unabhängige & digitale Finanzberatung für Viersen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
